import { Typography } from '@mui/material'
import { useState } from 'react'

interface TruncatedTextProps {
  content?: string
  textType?: string
  maxLength: number
}

const TruncatedAnswer = ({ content, textType, maxLength }: TruncatedTextProps) => {
  const [show, setShow] = useState(false)

  if (!content) return null

  const summaryText = content.replaceAll('\n', '<br>')
  const isTruncated = summaryText.length > maxLength

  const displayText = show || !isTruncated ? summaryText : summaryText.substring(0, maxLength)

  return (
    <div>
      {textType === 'question' && (
        <Typography
          variant="body2"
          color="text.primary"
          dangerouslySetInnerHTML={{
            __html: displayText + (isTruncated && !show ? '...' : '')
          }}
          // className="inline"
          fontWeight={700}
        />
      )}
      {textType === 'answer' && (
        <Typography
          variant="caption"
          color="text.secondary"
          dangerouslySetInnerHTML={{
            __html: displayText + (isTruncated && !show ? '...' : '')
          }}
          className="inline"
        />
      )}
      {textType === 'cell' && (
        <Typography
          variant="caption"
          color="text.primary"
          dangerouslySetInnerHTML={{
            __html: displayText + (isTruncated && !show ? '...' : '')
          }}
          className="inline"
        />
      )}
      {textType === 'h6' && (
        <Typography
          variant="h6"
          color="text.primary"
          dangerouslySetInnerHTML={{
            __html: displayText + (isTruncated && !show ? '...' : '')
          }}
          className="inline"
        />
      )}
      {textType === 'body1' && (
        <Typography
          variant="body1"
          color="text.secondary"
          dangerouslySetInnerHTML={{
            __html: displayText + (isTruncated && !show ? '...' : '')
          }}
          className="inline"
        />
      )}
      {textType === 'subtitle1' && (
        <Typography
          variant="subtitle1"
          color="text.primary"
          dangerouslySetInnerHTML={{
            __html: displayText + (isTruncated && !show ? '...' : '')
          }}
          className="inline"
        />
      )}
    </div>
  )
}

export default TruncatedAnswer
